import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.css'],
    standalone: false
})
export class AuthCallbackComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
     this.authService.completeAuthentication().then(() => {
       this.router.navigateByUrl('/crypt');
     });
  }

}
